import Component from 'gia/Component'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import _each from 'lodash.foreach'

gsap.registerPlugin(ScrollTrigger);

class Grid extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element

    this.ref = {
      img: [],
      planes: [],
      images: null,
      text: null
    }

  }

  mount() {


      _each(this.ref.img, (el)=> {

        const o = parseFloat(el.dataset.p)

        this.animation = gsap.fromTo(el,
          {
            yPercent: 50*o,
            ease: "none",
          },
          {
          yPercent: -150*o,
          ease: "none",
          scrollTrigger: {
            id: "trigger1",
            trigger: this.element,
            start: "top top", // the default values
            end: "bottom top",
            scrub: 2
          },
        });

      })

      this.animation1 = gsap.fromTo(this.ref.text,
        {
          yPercent: 10,
          ease: "none",
        },
        {
        yPercent: -40,
        ease: "none",
        scrollTrigger: {
          id: "trigger2",
          trigger: this.element,
          start: "top top", // the default values
          end: "bottom top",
          scrub: .5
        },
      });

  }


  unmount() {

    this.animation.ScrollTrigger.kill();
    this.animation1.ScrollTrigger.kill();

  }


}

module.exports = Grid
